import React, {Component} from 'react';
import {Col, Container, Row, Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink} from 'reactstrap';
import {Link, animateScroll as scroll} from 'react-scroll';
import classNames from 'classnames';
import './StickyPageNav.scss';

export class WelcomeNav extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div className={classNames(`sticky-nav background-white`, this.props.className)}>
        <Container>
          <Navbar className={classNames(`navbar-sticky justify-content-end`)} expand="lg" light>
            <NavbarToggler onClick={this.toggle} />

            <Collapse className="justify-content-center" isOpen={this.state.isOpen} navbar>
              <Nav navbar>
                <NavItem>
                  <NavLink
                    className="sticky-nav-list-item"
                    activeClass="active"
                    spy={true}
                    offset={-55}
                    to="step-1"
                    smooth={true}
                    href="#"
                    tag={Link}
                  >
                    Step 1: Check out the speakers
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="sticky-nav-list-item"
                    activeClass="active"
                    spy={true}
                    offset={-55}
                    to="step-2"
                    smooth={true}
                    href="#"
                    tag={Link}
                  >
                    Step 2: Own it for Life
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="sticky-nav-list-item"
                    activeClass="active"
                    spy={true}
                    offset={-55}
                    to="step-3"
                    smooth={true}
                    href="#"
                    tag={Link}
                  >
                    Step 3: Spread the Word
                  </NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        </Container>
      </div>
    );
  }
}

export class SalesNav extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div className={classNames(`sticky-nav background-white`, this.props.className)}>
        <Container>
          <Navbar className={classNames(`navbar-sticky justify-content-end`)} expand="lg" light>
            <NavbarToggler onClick={this.toggle} />

            <Collapse className="justify-content-center" isOpen={this.state.isOpen} navbar>
              <Nav navbar>
                <NavItem>
                  <NavLink
                    className="sticky-nav-list-item"
                    activeClass="active"
                    spy={true}
                    offset={-55}
                    to="why"
                    smooth={true}
                    href="#"
                    tag={Link}
                  >
                    Why This Program
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="sticky-nav-list-item"
                    activeClass="active"
                    spy={true}
                    offset={-55}
                    to="hosts"
                    smooth={true}
                    href="#"
                    tag={Link}
                  >
                    Instructor Profile
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="sticky-nav-list-item"
                    activeClass="active"
                    spy={true}
                    offset={-55}
                    to="learn"
                    smooth={true}
                    href="#"
                    tag={Link}
                  >
                    What You'll Learn
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="sticky-nav-list-item"
                    activeClass="active"
                    spy={true}
                    offset={-55}
                    to="bonuses"
                    smooth={true}
                    href="#"
                    tag={Link}
                  >
                    Bonuses
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="sticky-nav-list-item"
                    activeClass="active"
                    spy={true}
                    offset={-55}
                    to="enroll"
                    smooth={true}
                    href="#"
                    tag={Link}
                  >
                    Enroll Now
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="sticky-nav-list-item"
                    activeClass="active"
                    spy={true}
                    offset={-55}
                    to="faq"
                    smooth={true}
                    href="#"
                    tag={Link}
                  >
                    FAQs
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="sticky-nav-list-item"
                    activeClass="active"
                    spy={true}
                    offset={-55}
                    to="testimonials"
                    smooth={true}
                    href="#"
                    tag={Link}
                  >
                    What Students Say
                  </NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        </Container>
      </div>
    );
  }
}
